document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.banner-hero');
  if (hero) {
    requestAnimationFrame(() => {
      hero.classList.add('is-visible');
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const animatedElements = document.querySelectorAll('.use-animate');
  const windowHeight = window.innerHeight - 300;

  // To animate the blocks.
  if (animatedElements.length) {
    const containerPositions = [];
    
    // Save initial positions.
    animatedElements.forEach((el, index) => {
      const rect = el.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      containerPositions[index] = rect.top + scrollTop;
    });

    window.addEventListener('scroll', () => {
      const scrollPos = (window.pageYOffset || document.documentElement.scrollTop) + windowHeight;
    
      animatedElements.forEach((el, index) => {
        if (scrollPos >= containerPositions[index]) {
          el.classList.add('animated-executed');
        }
      });
    });
  }

  // Button for move the scroll to the Calendar block.
  const target = document.querySelector('.block-professional-calendar');
  if (!target) return;

  const triggers = document.querySelectorAll(
    '.banner-hero-content .container-field-link a, .btn-float-calendar'
  );

  const scrollToCalendar = () => {
    const targetTop =
      target.getBoundingClientRect().top + window.scrollY;

    document.querySelector('.wrapper-form-appointment').classList.add('is-active');
    document.querySelector('.block-professional-calendar').classList.add('is-active');
    document.body.classList.add('no-scroll');
    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  };

  triggers.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      scrollToCalendar();
    });
  });
});
